<template>
  <div class="antsupply">
    <TopHP title="ANTSUPPLY: Dropshipping One-stop Solution for Medium and Large Customers" :content="frontList"
      btn="Contact Us" img="/static/imgs/antsupply_top.svg" bg='top_bg_p_supply' tlcontent='top_left_content_supply'
      tlsymbol='top_left_symbol_supply'></TopHP>
    <div class="antsupply_content">
      <div class="antsupply_content_box">
        <div class="antsupply_content_line antsupply_content_line2">
          <img class="antsupply_content_line_img" src="/static/imgs/antsupply_1.png">
          <div class="antsupply_content_line_text antsupply_content_line_text_odd">
            <div class="title_icon antsupply_content_line_text_symbol_1"></div>
            <div class="antsupply_content_line_text_title">Import Products with 1-click</div>
            <div class="antsupply_content_line_text_subtitle">Quickly add trending products from 1688 and oversea
              self-operated warehouses</div>
            <div class="antsupply_content_line_text_content">We have billions of products from the 1688 platform and
              overseas self-operated warehouses.You can directly purchase or import them to your store with a single
              click of the mouse.</div>
          </div>
        </div>
        <div class="antsupply_content_line">
          <div class="antsupply_content_line_text antsupply_content_line_text_even">
            <div class="title_icon antsupply_content_line_text_symbol_2"></div>
            <div class="antsupply_content_line_text_title">Don't Worry about Logistics and Transportation</div>
            <div class="antsupply_content_line_text_subtitle">Full logistics tracking</div>
            <div class="antsupply_content_line_text_content">We send the purchased products directly to the Chinese
              warehouse and then forward to your customer's area.</div>
          </div>
          <img class="antsupply_content_line_img" src="/static/imgs/antsupply_2.png">
        </div>
        <div class="antsupply_content_line antsupply_content_line2">
          <img class="antsupply_content_line_img" src="/static/imgs/antsupply_3.png">
          <div class="antsupply_content_line_text antsupply_content_line_text_odd">
            <div class="title_icon antsupply_content_line_text_symbol_3"></div>
            <div class="antsupply_content_line_text_title">Automated Supply Chain Integration</div>
            <div class="antsupply_content_line_text_subtitle">Easily manage all your orders in one place</div>
            <div class="antsupply_content_line_text_content">Our complete supply chain system can help you quickly and
              automatically sync orders, track order delivery, save time and human resources, ensure smooth businiess
              operation.</div>
          </div>
        </div>
        <div class="antsupply_content_line">
          <div class="antsupply_content_line_text">
            <div class="title_icon antsupply_content_line_text_symbol_4 antsupply_content_line_text_even"></div>
            <div class="antsupply_content_line_text_title">Cross-border Direct Purchase Service</div>
            <div class="antsupply_content_line_text_subtitle">Direct purchase of Chinese products in foreign currency
            </div>
            <div class="antsupply_content_line_text_list"><em></em>Support large payment for a single order.</div>
            <div class="antsupply_content_line_text_list"><em></em>Foreign funds are directly used for 1688 purchases.
            </div>
            <div class="antsupply_content_line_text_list"><em></em>Cross-border supply guarantee for high-quality
              merchants.</div>
            <div class="antsupply_content_line_text_list"><em></em>Alipay official services are more compliant and more
              assured.</div>
            <div class="antsupply_content_line_text_list"><em></em>Provide competitive exchange rates and rates.</div>
          </div>
          <img class="antsupply_content_line_img" src="/static/imgs/antsupply_4.png">
        </div>
      </div>
      <div class="antsupply_content_bg antsupply_content_bg1"></div>
      <div class="antsupply_content_bg antsupply_content_bg2"></div>
      <div class="antsupply_content_bg antsupply_content_bg3"></div>
    </div>
    <div class="ant_faqs">
      <div class="ant_faqs_box">
        <div class="ant_faqs_title">
          <div class="title_icon"></div>FREQUENTLY ASKED QUESTIONS
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_1.svg">
          <div>
            <div class="ant_faqs_line_title">How can l use ANTSUPPLY?</div>
            <div class="ant_faqs_line_text ant_faqs_line_text_1">You can communicate with us through the chat window in
              the lower right
              corner.You can also communicate with us via email and WhatsApp.</div>
            <div class="ant_faqs_line_text ant_faqs_line_text_2">Email: support@ant3r.com</div>
            <div class="ant_faqs_line_text ant_faqs_line_text_3">WhatsApp: +86 16734879588</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_2.svg">
          <div>
            <div class="ant_faqs_line_title">What e-commerce platforms does ANTSUPPLY support?</div>
            <div class="ant_faqs_line_text">Currently we integrate with Shopify and Lazada.</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_3.svg">
          <div>
            <div class="ant_faqs_line_title">Will ANTSUPPLY work for my country?</div>
            <div class="ant_faqs_line_text">Yes! Since suppliers ship the items directly to your customers, dropshipping
              is borderless and can be done from anywhere in the world.</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_4.svg">
          <div>
            <div class="ant_faqs_line_title">What supply platforms do we support?</div>
            <div class="ant_faqs_line_text">Currently we are cooperating with 1688.We also provide overseas sel-operated
              warehouse products. We are planning to cooperate with Amazon,Taobao, Tmall and other platforms.</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_5.svg">
          <div>
            <div class="ant_faqs_line_title">Does ANTSUPPLY charge?</div>
            <div class="ant_faqs_line_text">No, our products and services are completely free, there are no hidden
              charges or taxes.</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import TopHP from './common/topHP.vue'

export default {
  name: 'AntSupply',
  components: {
    Header,
    Footer,
    TopHP
  },
  data () {
    return {
      frontList: [{
        msg: 'Directly connected to the 1688 platform and overseas self-operated warehouses, providing you with billions of products.'
      }, {
        msg: 'We provide you with a one-stop solution to purchase cross-border products as simply and reliably as they do from local quality suppliers.'
      }, {
        msg: 'Provide competitive exchange rates and exchange rates, purchase products directly in foreign currencies.'
      }, {
        msg: 'Commodity sourcing services to help you find cheaper and high-quality alternatives.'
      }]
    }
  }
}
</script>

<style scoped>
.antsupply_content {
  background: #f6f7fa;
  position: relative;
  overflow: hidden;
}
.antsupply_content_box {
  width: 1200px;
  padding: 120px 0 20px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.antsupply_content_line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 100px;
}
.antsupply_content_line_text {
  width: 580px;
  flex: 1;
}
.antsupply_content_line_text_odd {
  margin-left: 75px;
}
.antsupply_content_line_text_even {
  margin-right: 49px;
}
.antsupply_content_line_text_symbol_1 {
  margin: 70px 0 27px;
}
.antsupply_content_line_text_symbol_2 {
  margin: 70px 0 27px;
}
.antsupply_content_line_text_symbol_3 {
  margin: 83px 0 27px;
}
.antsupply_content_line_text_symbol_4 {
  margin: 25px 0 27px;
}
.antsupply_content_line_text_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin-bottom: 25px;
}
.antsupply_content_line_text_subtitle {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fc5322;
  line-height: 28px;
  margin-bottom: 20px;
}
.antsupply_content_line_text_content {
  font-size: 20px;
  font-family: Helvetica;
  color: #222536;
  line-height: 30px;
}
.antsupply_content_line_text_list {
  width: 700px;
  height: 26px;
  font-size: 22px;
  font-family: Helvetica;
  color: #222536;
  line-height: 26px;
  display: flex;
  align-items: center;
}
.antsupply_content_line_text_list em {
  display: inline-block;
  width: 8px;
  height: 4px;
  background: #fc5421;
  border-radius: 2px;
  margin-right: 8px;
  flex: 0 0 auto;
}
.antsupply_content_line_text_list + .antsupply_content_line_text_list {
  margin-top: 20px;
}
.antsupply_content_line_img {
  width: 489px;
  height: 400px;
}

.antsupply_content_bg {
  position: absolute;
  width: 2000px;
  height: 510px;
  border-radius: 255px;
  opacity: 0.79;
  border: 120px solid #ffffff;
}
.antsupply_content_bg1 {
  top: 271px;
  left: 1128px;
}
.antsupply_content_bg2 {
  top: 816px;
  left: -1575px;
}
.antsupply_content_bg3 {
  top: 1337px;
  left: 1128px;
}

.ant_faqs {
  background: #ffffff;
}
.ant_faqs_box {
  width: 1200px;
  margin: 0 auto;
}
.ant_faqs_title {
  height: 95px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.ant_faqs_title > div {
  margin: 80px auto 27px;
}
.ant_faqs_line {
  width: 1200px;
  display: flex;
  margin-top: 25px;
}
.ant_faqs_line > img {
  margin-right: 15px;
  align-self: start;
}
.ant_faqs_line_title {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fc5322;
  line-height: 29px;
  margin-bottom: 15px;
}
.ant_faqs_line_text {
  font-size: 22px;
  font-family: Helvetica;
  color: #222536;
  line-height: 28px;
  margin-bottom: 15px;
}
.ant_faqs_line:nth-child(6) {
  padding-bottom: 105px;
}

@media (max-width: 767px) {
  .antsupply_content_bg {
    display: none;
  }
  .antsupply_content {
    background: #f6f7fa;
    position: relative;
    overflow: hidden;
    width: 100%;
    padding: 0 0.48rem 0.76rem;
  }
  .antsupply_content_box {
    width: 100%;
    padding: 0;
    margin: 0 auto;
    /* position: relative; */
    z-index: 1;
  }
  .antsupply_content_line {
    flex-direction: column;
    height: auto;
    margin-bottom: 0.2rem;
  }
  .antsupply_content_line_text {
    width: 100%;
  }
  .antsupply_content_line_text_odd {
    margin-left: 0;
  }
  .antsupply_content_line_text_even {
    margin-right: 0;
  }
  .title_icon {
    margin: 0.8rem 0 0.31rem;
  }
  .antsupply_content_line_text_title {
    height: auto;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
    margin-bottom: 0.15rem;
  }
  .antsupply_content_line_text_subtitle {
    height: auto;
    font-size: 0.28rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #fc5322;
    line-height: 0.34rem;
    margin-bottom: 0.2rem;
  }
  .antsupply_content_line_text_content {
    width: 100%;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.32rem;
  }
  .antsupply_content_line_text_list {
    width: 100%;
    height: auto;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.29rem;
    display: flex;
    align-items: flex-start;
  }
  .antsupply_content_line_text_list em {
    display: inline-block;
    width: 0.1rem;
    height: 0.04rem;
    background: #fc5421;
    border-radius: 0.02rem;
    margin-right: 0.08rem;
    margin-top: 0.1rem;
    flex: 0 0 auto;
  }
  .antsupply_content_line_text_list + .antsupply_content_line_text_list {
    margin-top: 0.15rem;
  }
  .antsupply_content_line_img {
    width: 100%;
    height: auto;
    margin-top: 0.5rem;
  }
  .antsupply_content_line2 {
    flex-direction: column-reverse;
  }

  .ant_faqs {
    background: #ffffff;
  }
  .ant_faqs_box {
    width: 100%;
    margin: 0 auto;
    padding: 0 0.48rem;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .ant_faqs_title {
    width: 4.78rem;
    height: 1.11rem;
    font-size: 0.48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.55rem;
    text-align: center;
  }
  .ant_faqs_title > .title_icon {
    display: none;
  }
  .ant_faqs_title {
    margin: 0.7rem 0 0.4rem;
  }
  .ant_faqs_line {
    width: 100%;
  }
  .ant_faqs_line > img {
    width: 0.28rem;
    margin: 0.06rem 0.15rem 0 0;
    align-self: start;
  }
  .ant_faqs_line_title {
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #fc5322;
    line-height: 0.36rem;
    margin-bottom: 0.15rem;
  }
  .ant_faqs_line_text {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.3rem;
    margin-bottom: 0.5rem;
  }
  .ant_faqs_line_text_1,
  .ant_faqs_line_text_2 {
    margin-bottom: 0.15rem;
  }
  .ant_faqs_line:nth-child(6) {
    padding-bottom: 0.7rem;
  }
}
</style>
<style>
.top_bg_p_supply {
  width: 1243px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.55;
  border: 120px solid #f6f7fa;
  position: absolute;
  top: 52px;
  left: -836px;
}
.top_left_symbol_supply {
  margin: 23px 0 21px !important;
}
.top_left_content_supply {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 21px;
  margin-bottom: 12px;
  color: #32404d;
  display: flex;
  align-items: flex-start;
}
.top_left_content_supply > em {
  margin-top: 4px;
}
@media (max-width: 767px) {
  .top_bg_p_supply {
    display: none;
  }
  .top_left_content_supply {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.3rem;
    margin: 0.3rem 0 0;
    color: #222536;
    display: flex;
    align-items: flex-start;
  }
  .top_left_content_supply > em {
    margin: 0.08rem 0.17rem 0 0 !important;
  }
  .top_left_content_supply:nth-child(4) {
    margin-bottom: 0.4rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/antSupply.vue